import type { ReactNode } from 'react';
import { Link } from '../../lib/routing';
import Header from '../../components/header';

/* Coque commune aux pages légales publiques (politique, CGU). Tokens de texte
   uniquement (text-foreground / text-muted-foreground), lisible à 360px. */
export function LegalLayout({ title, updated, children, seeAlso }: { title: string; updated: string; children: ReactNode; seeAlso?: { to: string; label: string } }) {
  return (
    <div className="min-h-dvh bg-background flex flex-col">
      <Header />
      <main className="w-full max-w-[760px] mx-auto px-4 py-8 flex-1">
        <h1 className="text-[24px] font-extrabold text-foreground tracking-[-0.01em] mb-1">{title}</h1>
        <p className="text-[12.5px] text-muted-foreground mb-4">Dernière mise à jour : {updated}</p>
        <div className="rounded-card border border-border bg-card p-3 text-[12.5px] text-muted-foreground mb-6">
          Version 1, en cours de validation juridique. Ce document décrit nos pratiques actuelles ;
          sa formulation définitive sera arrêtée avec notre conseil.
        </div>
        <div className="flex flex-col gap-5 text-[14px] leading-[1.6] text-foreground">{children}</div>
        {/* Rendu seulement si une cible est fournie, et jamais vers la page courante :
            la page qui EST la cible (ex. /cgu) ne passe pas seeAlso, le renvoi disparaît. */}
        {seeAlso && (
          <p className="text-[12.5px] text-muted-foreground mt-8">
            Voir aussi : <Link to={seeAlso.to} className="text-naia-blue underline inline-block py-3">{seeAlso.label}</Link>.
          </p>
        )}
      </main>
    </div>
  );
}

export function LegalSection({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-[16px] font-bold text-foreground mb-1.5">{heading}</h2>
      <div className="flex flex-col gap-2 text-muted-foreground">{children}</div>
    </section>
  );
}
